import http from 'hub-http/clients/apiClient';
const FORM_API_BASE = '/forms/v2/forms';
const WEBINAR_FORM_ELIGIBLE_API = `${FORM_API_BASE}/webinar-eligible`;
export const formEligible = (formGuid, property) => {
  return http.post(`${WEBINAR_FORM_ELIGIBLE_API}/${formGuid}`, {
    data: [...property]
  });
};